import gql from 'graphql-tag';

export default gql`
	query FieldCollectionQuery($id: ID!) {
		fieldCollection(id: $id) {
			id
			type
			inputName
			question
			config {
				mostBeNum
				numMin
				numMax
			}
			answers {
				label
				value
				config {
					mostBeNum
					numMin
					numMax
      		replica
      		replicaLabel
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/queries/fetchFieldCollectionById.js